{
  "customer-register-form": {
    "text": {
      "accept": "Ich akzeptiere die ",
      "agb": "Allgemeine Geschäftsbedingungen",
      "required": "*) Pflichtangabe"
    }
  }
}
